export const getSessionStorageItem = <T>(key: string): T | null => {
  const data = sessionStorage.getItem(key);
  return data ? JSON.parse(data) : null;
};

export const setSessionStorageItem = <T>(key: string, data: T) => {
  sessionStorage.setItem(key, JSON.stringify(data));
};

export const cleanSessionStorageItem = (key: string) => {
  sessionStorage.removeItem(key);
};
export const cleanAllSessionStorage = () => {
  sessionStorage.clear();
};
